import { render, staticRenderFns } from "./AuditFindings.vue?vue&type=template&id=10a3b16c&"
import script from "./AuditFindings.vue?vue&type=script&lang=js&"
export * from "./AuditFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports